"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_PATH = exports.PATHS = exports.api_prefix = void 0;
const auth_1 = require("./auth");
const upload_1 = require("./upload");
const port = 9090;
let BASE_URI;
let hostname;
// Separate hostname assignment to avoid ReferenceError in Node
if (typeof window !== "undefined" && window.location) {
    hostname = window.location.hostname;
}
else {
    hostname = process.env.HOSTNAME || "localhost";
}
if (hostname.includes("tapzus")) {
    BASE_URI = "https://api.tapzus.com";
}
else {
    BASE_URI = `http://localhost:${port}`;
}
const hubixlabUtils = "/hubixlab_utils";
const payment = "/payment";
const app = "/app";
exports.api_prefix = "api";
exports.PATHS = {
    hubixlab_utils: hubixlabUtils,
    ...upload_1.FileUploadPath,
    payment,
    ...auth_1.AuthPath,
    app,
};
const handlePath = ({ BasePath, path }) => {
    const apiPath = {
        frontend: `${exports.api_prefix}${BasePath}/${path}`,
        backend: `/${path}`,
    };
    return apiPath;
};
const appApi = {
    getAppData: handlePath({
        BasePath: exports.PATHS.app,
        path: "data",
    }),
};
exports.API_PATH = {
    port,
    base_uri: `${BASE_URI}/`,
    fileUpload: upload_1.FILE_UPLOAD_API_PATH.uploadFile,
    app: appApi,
    auth: auth_1.AUTH_API_PATH
};
//# sourceMappingURL=index.js.map